export default __webpack_public_path__ + "static/media/Editor’s-Choice.d824f6b9.svg";